module.exports = __webpack_public_path__ + "img/74.03c83fbc.jpg";